// 🔥 Saneador para gravação no Firestore — B289 (AI_127)
// ─────────────────────────────────────────────────────────────
// O Firestore REJEITA `undefined` no addDoc/setDoc ("Unsupported field value:
// undefined"), mas aceita `null`. Objetos com campos opcionais não preenchidos
// (ex.: DadosCargaViral, que zera campos só-da-genotipagem como `undefined`)
// quebram a gravação. Esta função remove recursivamente as chaves `undefined`,
// preservando `null`, `0`, `""`, `false`, arrays e datas.
//
// ⚠️ NÃO aplicar sobre sentinelas do Firestore (serverTimestamp/FieldValue):
// use ANTES de adicioná-los ao payload (eles não devem ser reconstruídos).
// ─────────────────────────────────────────────────────────────
export function removerUndefined<T>(valor: T): T {
  if (Array.isArray(valor)) {
    return valor.map((v) => removerUndefined(v)) as unknown as T;
  }
  if (valor && typeof valor === "object" && !(valor instanceof Date)) {
    const limpo: Record<string, unknown> = {};
    for (const [chave, v] of Object.entries(valor as Record<string, unknown>)) {
      if (v !== undefined) limpo[chave] = removerUndefined(v);
    }
    return limpo as T;
  }
  return valor;
}
